import type { JSX } from 'react';

import { Document, Image, Page, StyleSheet, View } from '@react-pdf/renderer';

import { ChangeLogoSVG } from './components/ChangeLogoSVG';

// Create styles
const styles = StyleSheet.create({
	page: {
		backgroundColor: 'white',
		border: '28pt',
		borderColor: 'black',
		borderStyle: 'solid',
		fontFamily: 'Noto Sans',
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'space-around',
		height: '100%',
		maxHeight: 736,
		paddingHorizontal: 70,
		paddingVertical: 40,
		position: 'relative',
	},
	image: { width: 415, height: 234, backgroundColor: 'grey', borderRadius: 16 },
	title: { height: 264, width: 415 },
	qrcode: { height: 138, width: 138, borderRadius: 8 },
	logo: { position: 'absolute', bottom: 0, right: 0 },
});

type FlyrCPDFProps = { petitionTitleDataURL: string; qrCodeDataURL: string; petitionImageSrc?: string };
export function FlyerCPDF({ petitionTitleDataURL, qrCodeDataURL, petitionImageSrc }: FlyrCPDFProps): JSX.Element {
	return (
		<Document>
			<Page size="LETTER" style={styles.page}>
				<View style={styles.content}>
					{/* petition image */}
					<Image src={petitionImageSrc} style={styles.image} />
					{/* petition title */}
					<Image src={petitionTitleDataURL} style={styles.title} />
					{/* qr code */}
					<Image style={styles.qrcode} src={qrCodeDataURL} />
					<View style={styles.logo}>
						<ChangeLogoSVG />
					</View>
				</View>
			</Page>
		</Document>
	);
}
